export const MOCK_PRODUCT_DETAILS = {
  "prod-101": {
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    manufacturer: "Schneider Electric",
    category: "Switchgears",
    uom: "Nos",
    listPrice: 450,
    status: "Active",
  },
  "prod-102": {
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    manufacturer: "Kirloskar Brothers",
    category: "Pumps & Hydraulics",
    uom: "Nos",
    listPrice: 12500,
    status: "Active",
  },
  "prod-103": {
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    manufacturer: "L&T Valves",
    category: "Valves & Fittings",
    uom: "Nos",
    listPrice: 8900,
    status: "End of Production",
  },
  "prod-104": {
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    manufacturer: "Philips Lighting",
    category: "Lighting Fixtures",
    uom: "Nos",
    listPrice: 320,
    status: "Active",
  },
};

export const MOCK_PRODUCT_WAREHOUSE_INVENTORY = {
  "prod-101": [
    {
      warehouseId: "wh-1",
      warehouseName: "Warehouse Bangalore",
      totalStock: 230,
      reservedStock: 60,
      maintenanceReserve: 20,
      defectiveStock: 10,
      availableStock: 140, // 230 - 60 - 20 - 10
      stockValue: 103500, // 230 * 450
      batches: [
        {
          batchNumber: "B-MCB-101",
          receiptDate: "2025-01-10",
          warrantyStart: "2025-01-10",
          warrantyEnd: "2026-06-30",
          totalQty: 150,
          reservedQty: 0,
          maintenanceQty: 10,
          defectiveQty: 0,
          availableQty: 140,
          status: "Available",
        },
        {
          batchNumber: "B-MCB-102",
          receiptDate: "2025-04-15",
          warrantyStart: "2025-04-15",
          warrantyEnd: "2026-08-31",
          totalQty: 80,
          reservedQty: 60,
          maintenanceQty: 10,
          defectiveQty: 10,
          availableQty: 0,
          status: "Reserved",
        },
      ],
    },
    {
      warehouseId: "wh-2",
      warehouseName: "Peelamedu Depot",
      totalStock: 60,
      reservedStock: 50,
      maintenanceReserve: 0,
      defectiveStock: 0,
      availableStock: 10,
      stockValue: 27000,
      batches: [
        {
          batchNumber: "B-MCB-201",
          receiptDate: "2025-03-05",
          warrantyStart: "2025-03-05",
          warrantyEnd: "2026-08-31",
          totalQty: 60,
          reservedQty: 50,
          maintenanceQty: 0,
          defectiveQty: 0,
          availableQty: 10,
          status: "Low Stock",
        },
      ],
    },
    {
      warehouseId: "wh-3",
      warehouseName: "Warehouse Mysore",
      totalStock: 0,
      reservedStock: 0,
      maintenanceReserve: 0,
      defectiveStock: 0,
      availableStock: 0,
      stockValue: 0,
      batches: [], // Empty state still renders the warehouse row
    },
  ],
  "prod-102": [
    {
      warehouseId: "wh-1",
      warehouseName: "Warehouse Bangalore",
      totalStock: 45,
      reservedStock: 40,
      maintenanceReserve: 5,
      defectiveStock: 0,
      availableStock: 0,
      stockValue: 562500, // 45 * 12500
      batches: [
        {
          batchNumber: "B-PMP-101",
          receiptDate: "2024-11-20",
          warrantyStart: "2024-11-20",
          warrantyEnd: "2025-11-30", // Expired
          totalQty: 45,
          reservedQty: 40,
          maintenanceQty: 5,
          defectiveQty: 0,
          availableQty: 0,
          status: "Expired Warranty",
        },
      ],
    },
    {
      warehouseId: "wh-3",
      warehouseName: "Warehouse Mysore",
      totalStock: 30,
      reservedStock: 0,
      maintenanceReserve: 0,
      defectiveStock: 0,
      availableStock: 30,
      stockValue: 375000,
      batches: [
        {
          batchNumber: "B-PMP-301",
          receiptDate: "2025-03-01",
          warrantyStart: "2025-03-01",
          warrantyEnd: "2026-03-31",
          totalQty: 30,
          reservedQty: 0,
          maintenanceQty: 0,
          defectiveQty: 0,
          availableQty: 30,
          status: "Available",
        },
      ],
    },
  ],
};
